export const blockIconsHardwareSecurity = (
	<span className='material-symbols-outlined'>security</span>
);
